<template>
  <div class="Leaflet">

    <v-card-text
      v-if="loading"
      class="text-xs-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-card-text>

    <div v-else>
      <v-layout justify-center row fill-height>
        <v-flex xs6>
          <div style="height: 90vh; width: 100%" >
            <l-map
              :zoom="zoom"
              maxNativeZoom=18
              :center="center"
              :options="mapOptions"
              style="height: 100%"
              @update:center="centerUpdate"
              @update:zoom="zoomUpdate"
            >
              <l-tile-layer
              :url="url"
              :attribution="attribution"
              :options="tileOptions"
              />

              <l-control :position="'bottomleft'" class="example-custom-control">
                <v-container>
                  <v-layout align-space-between column>
                    <v-dialog
                    v-model="dialog"
                    width="500"
                  >
                    <v-card >
                      <v-toolbar
                        color="error"
                        dark
                      >
                        <v-toolbar-title>
                          Cambio de Manzana
                        </v-toolbar-title>
                      </v-toolbar>

                      <v-card-text class="title">
                        ¿Está seguro que desea cambiar la manzana de esta encuesta?
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="gray"
                          @click="dialog=false"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="red"
                          @click="enviarCambio(encuesta_cambio, manzana_cambio)"
                        >
                          Aceptar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="dialog_error"
                      width="500"
                      >
                      <v-card>
                        <v-toolbar
                          color="error"
                          dark
                        >
                          <v-toolbar-title>
                            Cambio de Manzana
                          </v-toolbar-title>
                        </v-toolbar>

                        <v-card-text class="title">
                          Hubo un error cambiando la manzana
                        </v-card-text>

                        <v-divider></v-divider>

                      </v-card>
                    </v-dialog>
                    <v-card  dark width="150" >

                      <v-card-title primary-title>
                      <h3>Mapa Distancias</h3>
                      </v-card-title>

                      <v-card-text>
                        <!-- <v-layout align-space-between justify-start column fill-height> -->

                        <v-layout align-center justify-space-between row fill-height>
                          <v-flex >
                            <h3 class="font-weight-black">Centro Manzana</h3>
                          </v-flex>
                          <v-flex>
                            <v-icon left medium color="blue" >room</v-icon>
                          </v-flex>
                        </v-layout>
                        <v-divider ></v-divider>
                        <v-layout align-center justify-space-around row fill-height>
                          <v-flex >
                            <h3 class="font-weight-black">Manzana</h3>
                          </v-flex>
                          <v-flex>
                            <v-icon medium color="red darken-3" >crop_3_2</v-icon>
                          </v-flex>

                        </v-layout>
                        <v-divider ></v-divider>
                        <v-layout align-center justify-space-between row fill-height>
                          <v-flex >
                            <h3 class="font-weight-black">Manzana Sugerida</h3>
                          </v-flex>
                          <v-flex>
                            <v-icon left medium color="blue" >crop_3_2</v-icon>
                          </v-flex>
                        </v-layout>

                        <v-divider ></v-divider>
                        <v-layout align-center justify-space-between row fill-height>
                          <v-flex >
                            <h3 class="font-weight-black">Encuesta</h3>
                          </v-flex>
                          <v-flex>
                            <v-icon medium color="blue darken-3" >account_circle</v-icon>
                          </v-flex>
                        </v-layout>

                        <v-divider ></v-divider>
                        <v-layout align-center justify-space-between row fill-height>
                          <v-flex >
                            <h3 class="font-weight-black">Distancia</h3>
                          </v-flex>
                          <v-flex>
                            <v-icon medium color="green" >horizontal_rule</v-icon>
                          </v-flex>
                        </v-layout>

                      </v-card-text>

                    </v-card>
                  </v-layout>
                </v-container>
              </l-control>

              <l-control-scale position="topright" :imperial="true" :metric="true"/>

              <template v-if="maps_manzanas">
                <l-marker :lat-lng="markerLatLng">
                  <l-icon>
                    <v-icon :color="color_encuesta" size="40px">account_circle</v-icon>
                  </l-icon>
                </l-marker>
                <l-marker :lat-lng="markerManzana" :color="color_manzana">
                </l-marker>

                <l-polyline
                  :lat-lngs="polylineManzana.latlngs"
                  :color="polylineManzana.color"
                />

                <l-geo-json
                  :geojson="geojsonMan"
                  :options="optionGeoMan"

                />

                <!-- geojson y polyline manzana Sugerida -->
                <l-geo-json
                  :geojson="geojsonManSugerida"
                  :options="optionGeoManSugerida"
                />
              </template>

            </l-map>
          </div>

        </v-flex>
        <v-flex xs6>

          <v-card dark app>
            <v-card-title>
              <h2>DISTANCIAS</h2>
              <v-spacer></v-spacer>
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
            </v-card-title>

            <v-data-table
              :headers="headers"
              :items="dataVals"
              :search="search"
              item-key="encuesta"
              @click:row="rowClicked"
              v-model="selectedRows"
              class="mi-dataTable elevation-1"
              :pagination.sync ="propiedades_table"
              dense
              select-all
              >

              <template v-slot:headers="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"

                    @click="changeSort(header.value)"
                    :class="['column sortable', propiedades_table.descending ? 'desc' : 'asc', header.value === propiedades_table.sortBy ? 'active' : '']"
                  >
                    <v-layout row wrap>
                      <v-flex xs10>
                        <template v-if="header.text ==='Distancia Manzana Sugerida'">
                          <p>Distancia<br>Manzana<br>Sugerida</p>
                        </template>

                        <template v-else-if="header.text ==='Manzana Sugerida'">
                          <p >Manzana<br>Sugerida</p>
                        </template>

                        <template v-else>
                          {{ header.text }}
                        </template>

                      </v-flex>
                      <v-flex xs2>
                        <v-icon small>arrow_upward</v-icon>
                      </v-flex>
                    </v-layout>

                  </th>
                </tr>

              </template>
              <template v-slot:items="props">
                  <tr :class="selectedRows==props.item.encuesta?'cyan':''" class="mid-headercell" @click="rowClicked(props.item)">
                    <td class="text-xs-center">{{ parseInt(props.item.distancia) }}</td>
                    <td >{{ props.item.departamento }}</td>
                    <td >{{ props.item.municipio }}</td>
                    <td >{{ props.item.nombre }}</td>
                    <td >{{ props.item.cedula }}</td>
                    <!-- <td >{{ props.item.manzana }}</td> -->
                    <!-- <td >{{ props.item.manzana_sugerida }}</td> -->
                    <td >{{ parseInt(props.item.distancia_manzana_sugerida) }}</td>
                    <td class="midh-text">
                      <!-- <v-icon medium @click="download(props.item.audit)" color="green">cloud_download</v-icon> -->
                      <v-icon medium
                          @click="cambiarManzana(props.item.encuesta,props.item.manzana_sugerida)"
                          color="green"
                        >rate_review
                      </v-icon>
                    </td>
                  </tr>

              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </template>
            </v-data-table>

          </v-card>

        </v-flex>

      </v-layout>

    </div>

  </div>
</template>

<script>

import { latLng } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import { LMap, LIcon, LTileLayer, LPolyline, LControl, LMarker, LControlScale, LGeoJson } from 'vue2-leaflet'
// import { LMap, LTileLayer, LLayerGroup, LControlScale, LMarker, LPopup, LTooltip, LGeoJson } from 'vue2-leaflet'

export default {
  name: 'Mapa General',
  components: {
    LMap,
    LTileLayer,
    // LLayerGroup,
    LControlScale,
    LPolyline,
    LMarker,
    LIcon,
    // LPopup,
    LControl,
    LGeoJson
    // LPolygon
  },
  data: function () {
    return {
      backConf: {
        path: '/maps/distancia/',
        pathManzana: '/maps/manzana2020/',
        pathCambio: '/maps/cambiarManzana/'
      },

      dialog: false,
      dialog_error: false,
      loading: false,

      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      operativo: null,

      filter: [],

      filterBy: null,
      alert: false,

      markers: [],

      zoom: 7,
      center: latLng(4.60971, -74.08175),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      withPopup: latLng(4.60871, -74.11379),
      withTooltip: latLng(4.60971, -74.08175),
      currentZoom: 7,
      currentCenter: latLng(4.60971, -74.08175),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 23
      },
      tileOptions: {
        maxZoom: 23,
        maxNativeZoom: 19
      },

      clustering: true,
      clusterOptions: {},

      localidades: null,

      popupName: null,

      optionGeoMan: {
        style: function (feature) {
          return {
            weight: 3,
            color: 'red'
          }
        },
        onEachFeature: function onEachFeature (feature, layer) {
          if (feature.properties.ccnct) {
            layer.bindPopup(
              '<h3>Manzana</h3>' +
              '<h4>Ccnct:</h4> ' + feature.properties.ccnct + '<br/>' +
              '<h4>Municipio: </h4> ' + feature.properties.municipio + '<br/>'

            )
          } else {
            layer.bindPopup('Not in port')
          }
        }
      },

      optionGeoManSugerida: {
        style: function (feature) {
          return {
            weight: 3,
            color: '#2c93f3'
          }
        },
        onEachFeature: function onEachFeature (feature, layer) {
          if (feature.properties.ccnct) {
            layer.bindPopup(
              '<h3>Manzana Sugerida</h3>' +
              '<h4>Ccnct: </h4>' + feature.properties.ccnct + '<br/>' +
              '<h4>Municipio: </h4>' + feature.properties.municipio + '<br/>'
            )
          } else {
            layer.bindPopup('Not in port')
          }
        }
      },

      token: null,
      iconSize: 64,
      max: null,

      colores: [
        ['black', 'Muy Alto', '60% - 100%'],
        ['#D50000', 'Alto', '30% - 60%'],
        ['#B71C1C', 'Medio 3', '21% - 30%'],
        ['#E65100', 'Medio 2', '16& - 20%'],
        ['#FFAB00', 'Medio 1', '11% - 15%'],
        ['#FFEB3B', 'Bajo', '6% - 10%'],
        ['#64DD17', 'Muy Bajo', '0% - 5%']
      ],
      modelDpto: null,
      modelDpto2: null,
      departamentos: [],
      lista_dptos: [],

      maps_municipios: false,
      municipios: [],
      geojsonMuni: null,
      geojsonMuniPrueba: null,
      geomuni: [],
      geomuni2: [],

      geojsonDpto: null,
      geojsonDptoPrueba: null,
      geodpto: [],

      offset: 0,

      search: '',
      headers: [
        { text: 'Metros', value: 'distancia', width: '1%' },
        { text: 'Departamento', value: 'departamento', width: '1%' },
        { text: 'Municipio', value: 'municipio', width: '1%' },
        { text: 'Nombre', value: 'nombre', width: '50%' },
        { text: 'Cedula', value: 'cedula', width: '1%' },
        // { text: 'Manzana', value: 'manzana', width: '1%' },
        // { text: 'Manzana Sugerida', value: 'manzana_sugerida', width: '1%' },
        { text: 'Distancia Manzana Sugerida', value: 'distancia_manzana_sugerida', width: '1%' }
      ],

      maps_manzanas: false,

      geojsonMan: null,
      geojsonManPrueba: null,
      geoman: [],

      geojsonManSugerida: null,
      geojsonManPruebaSugerida: null,
      geomanSugerida: [],

      markerLatLng: [],
      markerManzana: [],
      selectedRows: [],

      polylineManzana: {
        latlngs: [],
        color: 'green'
      },

      polylineManzanaSugerida: {
        latlngs: [],
        color: 'green'
      },
      dataVals: [],

      color_encuesta: 'blue darken-2',
      color_manzana: 'blue ',

      nuevo: true,

      encuesta_cambio: null,
      manzana_cambio: null,
      cambios: [],

      propiedades_table: {
        descending: true,
        page: 1,
        rowsPerPage: 6, // -1 for All",
        sortBy: 'Fecha',
        width: '50%'
        // totalItems: number"
      }
    }
  },

  watch: {
    '$store.state.actualProject': function () {
      this.operativo = this.$store.state.actualProject.id
    }
  },

  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
    this.nuevo = false
    this.getDistancias()
  },

  methods: {
    download (data) {
      window.open(data.url)
    },

    getDistancias () {
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          operativo: this.operativo
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
        })
        .catch(err => console.error(err))
    },

    // Leaflet
    zoomUpdate (zoom) {
      this.currentZoom = zoom
    },
    centerUpdate (center) {
      this.currentCenter = center
    },
    showLongText () {
      this.showParagraph = !this.showParagraph
    },

    LatLongPoint (lat, long) {
      return latLng(lat, long)
    },

    /**
    * Funcion para poner en pop up propiedades
    * del marcador
    */
    openPopUp (latLng, caller) {
      this.p_cedula = null
      this.p_nombre = null
      this.token = caller
      this.getPersona()
      this.$refs.features.mapObject.openPopup(latLng)
    },

    mostrar (man, dis) {
      this.center = null
      let request = {
        method: 'get',
        url: this.backConf.pathManzana,
        params: {
          manzana: man.manzana
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          let features = resp.data.results.features
          let mLat = man.manzana_point.latitud
          let mLong = man.manzana_point.longitud

          let eLat = man.encuesta_point.latitud
          let eLong = man.encuesta_point.longitud

          t.loading = false
          t.maps_manzanas = true

          t.markerLatLng = [eLat, eLong]
          t.markerManzana = [mLat, mLong]

          t.center = latLng(eLat, eLong)

          t.geojsonMan = resp.data.results
          t.geojsonMan.features = features

          t.polylineManzana.latlngs = [[eLat, eLong], [mLat, mLong]]
          if (man.manzana_sugerida != null) {
            t.getManzanaSugerida(man)
          }

          t.cambiarZoom(dis)
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    getManzanaSugerida (man) {
      let request = {
        method: 'get',
        url: this.backConf.pathManzana,
        params: {
          manzana: man.manzana_sugerida
        }
      }
      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.geojsonManPruebasugerida = resp.data.results
          let featuresS = resp.data.results.features
          let mLatS = man.manzana_sugerida_point.latitud
          let mLongS = man.manzana_sugerida_point.longitud

          let eLatS = man.encuesta_point.latitud
          let eLongS = man.encuesta_point.longitud

          t.geomanSugerida = featuresS

          t.geojsonManSugerida = t.geojsonManPruebasugerida
          t.geojsonManSugerida.features = t.geomanSugerida

          t.polylineManzanaSugerida.latlngs = [[eLatS, eLongS], [mLatS, mLongS]]
        })
        .catch(function (err) {
          console.error(err)
        })
    },

    cambiarManzana (encuesta, manzana) {
      this.encuesta_cambio = encuesta
      this.manzana_cambio = manzana
      this.cambios = []
      let aux = [encuesta, manzana]
      this.cambios.push(aux)
      this.dialog = true
    },

    enviarCambio (encuesta, manzana) {
      this.dialog = false
      let request = {
        method: 'post',
        data: {
          operativo: this.operativo,
          cambios: this.cambios
        },
        url: this.backConf.pathCambio
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          if (resp.data.correctas.length > 0) {
            t.selectedRows.pop()
            var pos = t.dataVals.findIndex(i => i.encuesta === encuesta)

            t.dataVals.splice(pos, 1)
            t.nuevo = true

            t.currentCenter = latLng(4.60971, -74.08175)
            t.currentZoom = 7
            t.maps_manzanas = false
            t.polylineManzana.latLng = []
          } else {
            t.dialog_error = true
          }
        })
        .catch(function (err) {
          console.log(err)
        })
    },

    cambiarZoom (numero) {
      if (numero < 400) {
        this.zoom = 16.5
      } else if (numero < 600) {
        this.zoom = 15.5
      } else if (numero < 800) {
        this.zoom = 15.5
      } else if (numero < 5000) {
        this.zoom = 15
      } else if (numero < 17000) {
        this.zoom = 11
      } else if (numero < 20000) {
        this.zoom = 9
      } else {
        this.zoom = 8
      }
    },

    rowClicked (item) {
      this.toggleSelection(item.encuesta)
      this.mostrar(item, item.distancia)
    },

    toggleSelection (keyID) {
      if (this.selectedRows.length > 0) {
        this.selectedRows.pop()
        this.selectedRows.push(keyID)
      } else if (this.selectedRows.length === 0 && this.nuevo === false) {
        this.selectedRows.push(keyID)
      } else {
        this.nuevo = false
      }
    },

    changeSort (column) {
      if (this.propiedades_table.sortBy === column) {
        this.propiedades_table.descending = !this.propiedades_table.descending
      } else {
        this.propiedades_table.sortBy = column
        this.propiedades_table.descending = false
      }
    }

  }
}
</script>

<style lang="stylus" scoped>
  .mi-dataTable{
      table-layout: fixed;
      .mid-headercell{
              text-align: left;
              background-color: $blue_accent;
              .midh-text{
                padding: 0px;
                padding-left: 0%;
                color: white;
                font-weight: 400;
              }
        }
  }
</style>
